import classNames from 'classnames';
import { useMemo } from 'react';
import { useActiveReportStore } from 'hooks/useActiveReportStore';
import * as ReportUtils from 'lib/reportUtils';
import { useReportsStore } from 'hooks/useReportsStore';
import { formatToLocalTimezone } from 'lib/utils';
import ReportIssueButton from './ReportIssueButton';
import { useNTContext } from '../NewTable/NTContext';
import { useAuthContext } from 'context/useAuthContext';
interface FooterProps {
  elementCount?: number;
}

export default function Footer({ elementCount = 0 }: FooterProps) {
  const selectedReport = useReportsStore(state => state.selectedReport);
  const { currentReport } = useActiveReportStore(state => ({
    currentReport: state.currentReport,
    status: state.status,
  }));

  const { dismissedAudit } = useNTContext();
  const { isInternalUser } = useAuthContext();

  const reportSections = useMemo(() => {
    return currentReport ? currentReport.sections : [];
  }, [currentReport]);

  const rows: any[] = currentReport && reportSections ? ReportUtils.collectRows(Array.from(reportSections) as any) : [];
  const rowCount: number = rows.length;

  const updatedAt = formatToLocalTimezone(currentReport?.updatedAt || selectedReport?.updatedAt, 'MM/dd/yyyy hh:mm aa');

  const auditReportResult = useMemo(() => {
    let result;
    if (!currentReport?.result && currentReport?.audit && currentReport.audit.length > 0) {
      result = ReportUtils.calculateResultFromAudit(currentReport.audit);
    } else {
      result = currentReport?.result;
    }
    // Add dismissed count from dismissedAudit context
    if (result && dismissedAudit) {
      const localDismissedCount = dismissedAudit.filter(da => da.isDismissed === true).length;
      return {
        ...result,
        dismissed: (result.dismissed || 0) + localDismissedCount,
        total: (result.total || 0) + localDismissedCount,
      };
    }
    return result;
  }, [currentReport, dismissedAudit]);
  return (
    <div className="Layout-footer-container">
      <div className={classNames('Layout-footer')}>
        <div className="footer-counter-wrapper">
          <div className="footer-counter">{rowCount + ' items'}</div>
          {auditReportResult && (
            <div className="footer-audit-validation">
              <span>Audit: </span>
              <span className="error-count pass"> Pass: {auditReportResult.pass || 0}</span>
              <span className="error-count error"> Error: {auditReportResult.error || 0}</span>
              <span className="fail-count fail"> Fail: {auditReportResult.fail || 0}</span>
              <span className="dismissed-count dismissed"> Dismissed: {auditReportResult.dismissed || 0}</span>
              <span className="warning-count warning"> Warning: {auditReportResult.warning || 0}</span>
              <span className="total-count"> Total: {auditReportResult.total || 0}</span>
            </div>
          )}
        </div>
        <div className="footer-middle">
          <div className="footer-version">v{__APP_VERSION__}</div>
        </div>
        <div className="footer-right">
          <div className="footer-timestamp">{updatedAt && <span>UPDATED: {updatedAt}</span>}</div>
          {!isInternalUser && <ReportIssueButton />}
        </div>
      </div>
    </div>
  );
}
